import { bucket_url } from "../../../../../../../api/config/parameters"
import { EChoirFileType } from "../../../../../../../common/types/choir/file"

export const getLogoURL = (logo: string) => {
    return `${bucket_url}choir/${EChoirFileType.LOGO}-${logo}.jpg`
};
